/** 页面信息 */
const page = new (function () {
  this.title = ''
  this.icon = 'iconfont iconicon_group'
  this.name = 'penalize_folder'
  /**菜单编号 */
  this.code = 'penalize_folder'
  /**菜单别名 */
  this.aliasName = 'penalize_folder'
  /**路由地址 */
  this.path = '/penalize/penalizeFolder'
})()

/** 路由信息 */
export const route = {
  page,
  component: () => import('./index.vue')
}

export default page
